"use client";

import Image from "next/image";
import Link from "next/link";
import { mainlogo } from "@/images";
import { FaGithub, FaTelegram, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiFarcaster } from "react-icons/si";

const quickLinks = [
  { name: "Home", href: "/" },
  { name: "Protocol", href: "/protocol" },
  { name: "Community", href: "/community" },
];

const policies = [
  { name: "Use Policy", href: "/policies/acceptable-use-policy" },
  { name: "Cookie Policy", href: "/policies/cookie-policy" },
  { name: "User Agreement", href: "/policies/user-agreement" },
];

const newproposals = [
  { name: "WhitePaper ", href: "https://docsend.com/view/4j6qvvrudyr6izyb" },
  { name: "Bug Bounty", href: "/bug_bounty" },
];

export function Footer() {
  return (
    <footer className="text-black bg-[linear-gradient(to_bottom,_#F6F3E8_80%,_#BFBDB1_100%)]">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Logo & Description */}
          <div className="col-span-2">
            <Link href="/">
              <Image src={mainlogo} alt="BLOKC logo" width={200} height={50} />
            </Link>
            <p className="mt-4 text-black text-sm">
              Revolutionizing decentralized finance with secure and scalable
              blockchain solutions.
            </p>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((item, index) => (
                <li key={index}>
                  <Link
                    href={`${item.href}`}
                    className="hover:text-blue-500 transition-colors text-black"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Policies</h3>
            <ul className="space-y-2">
              {policies.map((item, index) => (
                <li key={index}>
                  <Link
                    href={`${item.href}`}
                    className="hover:text-blue-500 transition-colors text-black"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Resources</h3>
            <ul className="space-y-2">
              {newproposals.map((item, index) =>
                item.name === "WhitePaper" ? (
                  <li key={index}>
                    <Link
                      href={`${item.href}`}
                      target="_blank"
                      className="hover:text-blue-500 transition-colors text-black"
                    >
                      {item.name}
                    </Link>
                  </li>
                ) : (
                  <li key={index}>
                    <Link
                      href={`${item.href}`}
                      className="hover:text-blue-500 transition-colors text-black"
                    >
                      {item.name}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-12 border-t border-gray-300 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-black">
              &copy; {new Date().getFullYear()} BLOK Capital DAO LLC. All rights reserved.
            </p>
            <div className="flex gap-4 mt-4 md:mt-0 text-black">
              <Link href="https://github.com/BLOKCapital" target="_blank" aria-label="GitHub">
                <FaGithub size={24} />
              </Link>
              <Link href="https://t.me/blok_capital" target="_blank" aria-label="Telegram">
                <FaTelegram size={24} />
              </Link>
              <Link href="https://x.com/blok_cap" target="_blank" aria-label="X (Twitter)">
                <FaXTwitter size={24} />
              </Link>
              <Link href="https://warpcast.com/blokc" target="_blank" aria-label="Farcaster">
                <SiFarcaster size={24} />
              </Link>
              <Link href="https://www.youtube.com/@blokcapital" target="_blank" aria-label="YouTube">
                <FaYoutube size={24} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
